import { Tab, styled } from '@mui/material';

const CustomTab = styled(Tab)(() => ({
  minHeight: 'auto',
  marginLeft: 2,
  marginRight: 2,
}));

export default CustomTab;
